import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import TourManagementSidebar from "../components/tour/TourManagementSidebar";
import TourManagementChoice from "../components/tour/TourManagemetChoice";
import { tourPackageGuideOptions } from "../data/packageData";
import { Paths } from "../router/Paths";
import useOnLoadPage from "../hooks/useOnLoadPage";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../app/store";
import { setPackageData } from "../reducer/tourReducer";
import { usePackage } from "../hooks/usePackage";
import { addActiveTab } from "../reducer/sideBarSlice";

function TourManagementPackageGuideInfoPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { activityType, packageCategories, packageData } = useSelector(
    (state: RootState) => state.tour
  );
  const { createPrePackage } = usePackage();
  const progressref = useRef(6);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  useOnLoadPage({ tabActive: "create" });
  const { PrepackageDataId } = useSelector((state: RootState) => state.tour);

  const validateSelection = () => {
    if (!packageData.guideInformations) {
      setError("Please select a guide information option before continuing.");
      return false;
    }
    return true;
  };

  const onContinue = () => {
    if (!validateSelection()) return;
    dispatch(addActiveTab(Paths.tourManagementPackageFood));
    navigate(Paths.tourManagementPackageFood);
  };

  const onSelect = (option?: string) => {
    if (!option) return;
    setError("");
    dispatch(
      setPackageData({
        ...packageData,
        guideInformations: option,
      })
    );
  };

  const onSave = async () => {
    if (!validateSelection()) return;
    const updatedPackageData = {
      ...packageData,
      _id: PrepackageDataId,
      progress: Number(progressref.current),
      guideInformations: packageData.guideInformations,
    };

    console.log("Saving guide info:", updatedPackageData);
    dispatch(setPackageData(updatedPackageData));
    setLoading(true);

    try {
      await createPrePackage(updatedPackageData);
      localStorage.setItem("packageData", JSON.stringify(updatedPackageData));
      navigate(Paths.welcome);
    } catch (error) {
      console.error("Error saving package:", error);
    } finally {
      setLoading(false);
    }
  };

  console.log("Current package data:", packageData);

  const handleBack = () => {
    navigate(Paths.tourManagementPackageInclusion);
  };

  return (
    <div className={Classname.container}>
      <Navbar />
      <div className={Classname.content}>
        <TourManagementSidebar selected={7} />

        <div className={Classname.detail}>
          <TourManagementChoice
            selected={packageData.guideInformations || ""}
            onSelect={onSelect}
            options={tourPackageGuideOptions}
            className="mb-10"
          />

          {/* Display validation error */}
          {error && <p className="text-red-500 mb-4">{error}</p>}
          <div className="flex justify-between items-centers mt-10">
            <button className={Classname.saveButton2} onClick={handleBack}>
              Back
            </button>
            <div className={Classname.buttonsContainer}>
              <button
                className={Classname.saveButton}
                onClick={onSave}
                disabled={loading}
              >
                {loading ? "Please Wait..." : "Save and exit"}
              </button>
              <button className={Classname.continueButton} onClick={onContinue}>
                Continue
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TourManagementPackageGuideInfoPage;

const Classname = {
  container:
    "flex w-full min-h-screen relative bg-white flex-col items-center font-main",
  content:
    "flex flex-col lg:flex-row w-full max-w-7xl flex-1 pt-10 lg:pt-0 max-lg:px-4",
  detail: "flex flex-col py-10 lg:px-6 w-full",
  title: "font-bold text-lg mt-6 mb-2",
  input: "flex w-full h-14 border border-gray-400 rounded-md px-4 mt-2",
  description: "flex text-base mb-4",
  buttonsContainer: "flex max-lg:justify-between gap-3 max-lg:w-full",
  saveButton:
    "h-12 px-6 flex items-center lg:justify-center font-bold text-gray-700 border border-gray-500 rounded-md",
  saveButton2:
    "h-12 px-6 flex items-center lg:justify-center font-bold text-gray-700 border border-gray-500 rounded-md max-lg:hidden",
  continueButton:
    "h-12 px-6 flex items-center justify-center text-white font-bold bg-primary1 rounded-md",
};
